import { flatten } from 'ramda'

import { Config } from '@surglogs-app/types'
import { isProductionApp } from '@surglogs-app/util'

const checkConfigValues = (
  config: Record<string, any>,
  parentKey?: string,
): boolean[] =>
  flatten(
    Object.keys(config).map((key) => {
      if (typeof config[key] === 'object') {
        return checkConfigValues(config[key], key)
      }

      if (config[key] === '' || config[key] == null) {
        // eslint-disable-next-line no-console
        console.warn(
          ...[
            'Invalid config value for',
            key,
            ...(parentKey ? ['on', parentKey] : []),
          ],
        )
        return false
      }

      return true
    }),
  )

export const config: Config = {
  isProd: process.env.NODE_ENV !== 'development',
  appVersion:
    window.sessionStorage.getItem('version') || // NOTE: session storage only for testing purposes
    process.env.APP_VERSION,
  assetsPath: process.env.REACT_APP_ASSETS_PATH,
  sentryDsn:
    process.env.REACT_APP_SENTRY_DSN ||
    'https://0d4bd78c30374ea3ba326a5c163e4995@o276611.ingest.sentry.io/5693646',
  sentryProjectId: process.env.REACT_APP_SENTRY_PROJECT_ID || '5693646',
  // intercomId: process.env.REACT_APP_INTERCOM_ID || 'e9swkwio',
  intercomId: process.env.REACT_APP_INTERCOM_ID as string,
  posthog: {
    key: !isProductionApp()
      ? process.env.REACT_APP_POSTHOG_KEY_DEV
      : process.env.REACT_APP_POSTHOG_KEY,
    host: process.env.REACT_APP_POSTHOG_HOST as string,
  },
  trialRequestUrl:
    process.env.REACT_APP_TRIAL_REQUEST_URL ||
    'https://hooks.zapier.com/hooks/catch/4802272/br4ixyp/',
  trialRequestCalendlyUrl:
    process.env.REACT_APP_TRIAL_REQUEST_CALENDLY_URL ||
    'https://hooks.zapier.com/hooks/catch/4802272/3nm5dsp/',
  billingContactEmail:
    process.env.REACT_APP_BILLING_CONTACT_EMAIL || 'billing@surglogs.com',
  reCaptchaKey:
    process.env.REACT_APP_RECAPTCHA_KEY ||
    '6Le_-NofAAAAADZbYuxjueB5HJERchUDfrti1F7d',
  onlyofficeUrl:
    process.env.REACT_APP_ONLYOFFICE_URL ||
    'https://onlyoffice.shared.surglogs.com/',
}

if (process.env.NODE_ENV !== 'test') {
  checkConfigValues(config)
}
